import * as Sentry from '@sentry/react';

import {
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_SEND_DEFAULT_PII,
  SENTRY_TRACES_SAMPLE_RATE,
  SENTRY_DEBUG
} from '@common/config/environments';
import { APP_VERSION } from '../version';

export const sentryInit = () => {

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: `borrower-dashboard@v${APP_VERSION || '0.1.0'}`,
    initialScope: {
      tags: {
        application: 'borrower-dashboard',
        version: APP_VERSION
      }
    },
    ignoreErrors: [
      'Resource load error: SCRIPT',
    ],
    denyUrls: [
      /googletagmanager\.com/,
      /google-analytics\.com/,
      /inspectlet\.js/,
    ],
    sendDefaultPii: SENTRY_SEND_DEFAULT_PII,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    debug: SENTRY_DEBUG,
    beforeSend(event, hint) {
      if (event.tags?.testError ||
          (hint.originalException instanceof Error && hint.originalException.message?.includes('🧪 TEST ERROR'))) {
        event.fingerprint = [`test-error-${Date.now()}-${Math.random()}`];
        return event;
      }

      if (event.tags?.errorType === 'resourceLoadError') {
        const botPatterns = [
          /Google-Read-Aloud/i,
          /Googlebot/i,
          /bingbot/i,
          /AhrefsBot/i,
          /SemrushBot/i,
          /facebookexternalhit/i,
        ];
        if (botPatterns.some(p => p.test(navigator.userAgent))) {
          return null;
        }
      }

      if (event.exception) {
        const error = hint.originalException;

        if (error instanceof Error && error.message.includes('Network Error')) {
          return null;
        }

        if (error instanceof Error && error.message.includes('ResizeObserver')) {
          return null;
        }
      }

      return event;
    }
  });
}
